const AppStatus = {
  NO_CONTENT: "900",
  EXPIRED_DATE: "901",
  ASSESSMENT_LIMIT: "902",
  MONTHLY_ASSESSMENT_COUNT_LIMIT: "907",
  UNKNOWN_ERROR: "999",
} as const;

export type IAppStatus = typeof AppStatus[keyof typeof AppStatus];

export default AppStatus;
